import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "質問データインポート")
], -1)
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "カテゴリに質問データをインポートします。", -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "d-flex justify-content-center m-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("戻る")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary ms-2",
  type: "submit"
}, "アップロード", -1)

import { ref, unref } from 'vue'
import { useRouter } from 'vue-router'
import { useMessenger } from '@/plugins/message'
import { useNicotto, ConciergeCategory } from '@/plugins/nicotto'
import { useValidateForm } from '@/components/ui/validator'
import ConciergeHeaderQuestion from "@/components/parts/ConciergeHeaderQuestion.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportView',
  props: {
    categoryId: null
  },
  setup(__props: any) {

const props = __props as {
  categoryId: string
}



const router = useRouter()
const nicotto = useNicotto()
const messenger = useMessenger()

const category = ref<ConciergeCategory>()
nicotto.concierge.getCategory(props.categoryId)
  .then(data => {
    category.value = data
  })

const formRef = ref<HTMLFormElement>()
const errors = ref('')
let data: ArrayBuffer

const upload = (event: Event) => {
  const reader = new FileReader()
  reader.onloadend = async() => {
    data = reader.result as ArrayBuffer
  }
  if (event.target instanceof HTMLInputElement
    && event.target.files && event.target.files.length > 0) {
    reader.readAsArrayBuffer(event.target.files[0])
  }
}

const importData = async() => {
  if (!category.value || ! useValidateForm(unref(formRef) as HTMLFormElement).isValid()) {
    return
  }

  const importer = await nicotto.concierge.createCategoryImporter(category.value, data)
  if (importer.isValid()) {
    try {
      await importer.import()
      messenger.set('concierge.categories.importSucceeded')
      router.push(`/concierge/categories`)
    } catch (err) {
      console.log(err)
      messenger.set('concierge.categories.importFailed')
    }
  } else {
    errors.value = importer.getErrors().join('<br>')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (category.value)
      ? (_openBlock(), _createBlock(ConciergeHeaderQuestion, {
          key: 0,
          category: category.value
        }, null, 8, ["category"]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      ref_key: "formRef",
      ref: formRef,
      onSubmit: _withModifiers(importData, ["prevent"]),
      novalidate: ""
    }, [
      _hoisted_4,
      (errors.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            innerHTML: errors.value,
            class: "alert alert-danger",
            role: "alert"
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        type: "file",
        class: "form-control",
        accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        required: "",
        onChange: upload
      }, null, 32),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/concierge/categories",
          class: "btn btn-secondary",
          role: "button"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _hoisted_8
      ])
    ], 40, _hoisted_3)
  ]))
}
}

})